var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Provides the reusable contact information form used during appointment scheduling.
 * touches: appointment user contact data, contact validation and Claims IA design system components.
 * invariants: userContact is provided by the parent and never mutated directly; changes are emitted via update; validation errors show only when validation is provided.
 * inputs: userContact data and an optional validation context.
 * outputs: renders phone, email and address fields and emits partial contact updates to the parent.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiCard } from '@claims-ia/design-system';
let UserContactForm = class UserContactForm extends Vue {
};
UserContactForm = __decorate([
    Component({
        components: { UiCard },
        props: {
            userContact: {
                type: Object,
                required: true,
            },
            validation: {
                // todo use genrice AppointmentState type when Artisan and Expert are fusioned
                type: Object,
                default: null,
            },
        },
    })
], UserContactForm);
export default UserContactForm;
